import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import BackendClient from "../../BackendClient";
import Loader from "../../Components/Loading";
import DateFormat from "../../helpers/DateFormat";

const mapStateToProps = ({ identity }) => ({
  identity
});

class News extends Component {
  state = {
    isFetched: false,
    isFetching: false,
    items: null,
    page: 0,
    hasMore: false
  };

  componentWillUnmount() {
    this.isCancelled = true;
  }

  componentDidMount = () => {
    this.fetchItems();
  };

  fetchItems = () => {
    const { isFetched, isFetching, page, items } = this.state;
    if (!(isFetched && isFetching)) {
      !this.isCancelled &&
        this.setState({ isFetched: false, isFetching: true });
      !this.isCancelled &&
        BackendClient.getNews({ sort: "-published_at", page: page + 1 })
          .fetchJson()
          .then(data => {
            if (data) {
              const {
                items: articles,
                _meta: { /**totalCount,*/ pageCount }
              } = data;
              !this.isCancelled &&
                this.setState({
                  isFetched: true,
                  isFetching: false,
                  items: [...(items || []), ...(articles || [])],
                  page: page + 1,
                  hasMore: pageCount > page + 1
                });
            } else {
              this.setState({
                isFetched: true,
                isFetching: false,
                hasMore: false
              });
            }
          });
    }
  };

  render() {
    let logo;
    if (!this.props.identity.id) {
      logo = (
        <div className="logo">
          <Link to="/">
            <img src="/images/logo.png" alt="" />
          </Link>
        </div>
      );
    }

    const { isFetching, items, hasMore } = this.state;
    let loader;
    if (isFetching) {
      loader = <Loader loading />;
    }
    let loadMoreButton;
    if (hasMore) {
      loadMoreButton = (
        <a
          onClick={this.fetchItems}
          className="btn-border-white link-news link-news-button"
        >
          Показать еще
        </a>
      );
    }

    return (
      <div className="container">
        {logo}
        <div>
          <h1 className="text-center">Новости</h1>
          <div className="news-list">
            {(items || []).map(({ id, published_at, title }, index) => (
              <Link className="link-news" key={index} to={`/news/${id}`}>
                <li>
                  <div className="date">
                    {published_at &&
                      DateFormat.dateFromEpoch(published_at).ddmmyyyy()}
                  </div>
                  <div dangerouslySetInnerHTML={{ __html: title }} />
                </li>
              </Link>
            ))}
          </div>
          {loader}
          {loadMoreButton}
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps)(News);



// WEBPACK FOOTER //
// ./src/containers/news/index.jsx